// Shared UI constants for the Platform Admin (reasons only — data comes from APIs).

export const PLATFORM_BUSINESS_TABS = [
  { key: "all", label: "All" },
  { key: "active", label: "Active" },
  { key: "suspended", label: "Suspended" },
  { key: "banned", label: "Banned" },
];

export const PLATFORM_SUSPEND_REASONS = [
  "Billing / investigation",
  "Abuse / ToS violation",
  "Requested by owner",
  "Other",
];

export const PLATFORM_BAN_REASONS = [
  "Abuse / ToS violation",
  "Spam / fraudulent activity",
  "Repeated policy violations",
  "Other",
];
